import React from "react";
import { twMerge } from "tailwind-merge";

export const ListItem = ({
  label,
  value,
  valueNoWrap,
  valueClassName,
}: {
  label: string;
  value: string;
  valueNoWrap?: boolean;
  valueClassName?: string;
}) => (
  <div className="flex justify-between items-start gap-4">
    <p className="text-m md:text-l font-medium text-gray-800 dark:text-white shrink-0">
      {label}
    </p>
    <p
      className={twMerge(
        "text-m md:text-l font-medium text-gray-800 dark:text-white text-right break-words min-w-0",
        valueNoWrap && "whitespace-nowrap shrink-0",
        valueClassName,
      )}
    >
      {value}
    </p>
  </div>
);
